import React from 'react';
import styled, { css } from 'styled-components';
import { FlexColumn, FlexibleDiv } from '../../styled/common';
import { Typography } from '../ui/Typography';
import { FontWeight } from '../../styled/constants';

export const HeaderMenuWrapper = styled(FlexibleDiv)`
  width: 960px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 40px 0;

  @media screen and (max-width: 1039px) {
    padding: 40px;
  }

  @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 15px;
  }
`;

export const HeaderMenuColumn = styled(FlexColumn)`
  gap: 25px;

  @media screen and (max-width: 1439px) {
    gap: 20px;
  }

  &:last-child {
    align-items: flex-end;
  }
`;

export const itemStyles = css`
  position: relative;
  cursor: pointer;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text.primary};
  text-decoration: none;
  font-weight: ${FontWeight.thin};
  transition: color 0.2s ease-in-out;

  @media screen and (max-width: 1439px) {
    font-size: 15px;
  }

  ${({ selected }) =>
    selected &&
    css`
      font-weight: 500;
      color: ${({ theme }) => theme.colors.systemColors.brand};
    `}

  &:hover {
    color: ${({ theme }) => theme.colors.systemColors.brand};
  }
`;

export const HeaderMenuColumnItem = styled(
  ({ component: Component, ...props }) => <Component {...props} />
)`
  ${itemStyles}
`;

export const Label = styled.span`
  position: absolute;
  bottom: 14px;
  left: 120px;
  line-height: 18px;
  background: #77c81d;
  border-radius: 50px;
  color: #fff;
  padding: 0 5px;
  font-size: 12px;
`;

export const BuildLink = styled.a`
  ${itemStyles}
`;

export const ChangeLanguageButtonContainer = styled.div`
  display: flex;
  cursor: pointer;

  & svg,
  & button {
    transition:
      color 0.3s ease-in-out,
      fill 0.3s ease-in-out;
  }

  &:hover svg {
    fill: ${({ theme }) => theme.colors.systemColors.brand};
  }

  &:hover button {
    color: ${({ theme }) => theme.colors.systemColors.brand};
  }

  & button {
    cursor: pointer;
    background-color: transparent;
    font-size: 16px;
    font-weight: ${FontWeight.thin};
    padding-right: 0;
    padding-left: 5px;
  }

  @media screen and (max-width: 1439px) {
    & button {
      font-size: 15px;
    }
  }
`;

export const ContactUsTitle = styled(Typography).attrs({
  tag: 'h3'
})`
  margin-bottom: 3px;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: end;
  font-weight: ${FontWeight.thin};

  @media screen and (max-width: 1439px) {
    font-size: 15px;
  }
`;

export const ContactUsLink = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  font-size: 16px;
  text-align: end;
  transition: color 0.2s ease-in-out;

  ${({ styles }) => styles};

  @media screen and (max-width: 1439px) {
    font-size: 15px;
  }

  svg path {
    transition: fill 0.3s ease-in-out;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.systemColors.brand};
  }

  &:hover svg path {
    fill: ${({ theme }) => theme.colors.systemColors.brand};
  }
`;

export const ContactUsIcon = styled.i`
  display: block;
  position: relative;
  width: 23px;
  height: 23px;

  & svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
